//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteBlockType } from './Enums';

export abstract class WebsiteBlockUpdateItem extends ItemBase {
    WebsiteID: string | null = null;
    WebsitePageID: string | null = null;
    OrderIndex?: number;
    abstract readonly WebsiteBlockType: WebsiteBlockType;

    static readonly ClassName: string = "WebsiteBlockUpdateItem";
}
